{
  "pt_BR": "pousadas",
  "cs_CZ": "noclehy-se-snidani",
  "da_DK": "bed-and-breakfast",
  "de_DE": "bed-and-breakfast",
  "en_GB": "bed-and-breakfasts",
  "es_ES": "pensiones",
  "fi_FI": "aamiaismajoituspaikkaa",
  "fr_FR": "chambres-hotes",
  "it_IT": "bed-and-breakfast",
  "ja_JP": "asashokutsukikisu",
  "ko_KR": "chimdae-mich-achimsigsajegong-sugso",
  "nl_NL": "bed-en-breakfasts",
  "nb_NO": "bed-and-breakfast",
  "pl_PL": "noclegi-ze-sniadaniem",
  "pt_PT": "pensoes",
  "ru_RU": "nochleg-i-eavtrak",
  "sv_SE": "bed-en-breakfast",
  "tr_TR": "pansiyonlar",
  "zh_CN": "minsu"
}
